import moment from 'moment';

export const fields = [
  'incoterms',
  'psl',
  'shipment',
  'incotermnamedPlace',
  'ami',
  'po',
  'transportationGroup',
  'urgency',
];

export const transportationGroupRules = [{ required: true, message: 'Please select a Transportation group' }];

export const shipDateRules = (t) => {
  const currentDate = moment(new Date());
  const formattedCurrentDate = currentDate.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  return [
    {
      required: true,
      message: t('translation:default.fields.shipDate.message'),
    },
    {
      validator: (_, value) => {
        const formattedValue = value?.set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        if (value && formattedValue.isBefore(formattedCurrentDate)) {
          return Promise.reject(t('translation:getQuote.shippingTermsSearch.shipDate.message'));
        }

        return Promise.resolve();
      },
    },
  ];
};

export const shipmentRules = (amiValue, poValue) => [
  {
    validator: (_, value) => {
      if ([value, amiValue, poValue].some((v) => Boolean(v))) {
        return Promise.resolve();
      }

      return Promise.reject('At least one of Billing Reference#, Shipment#, PO# field should be filled');
    },
  },
  {
    max: 100,
    message: 'Shipment# cannot be longer than 100 characters',
  },
];

export const urgencyRules = [{ required: true, message: 'Please select a Shipment Type' }];

export const deliveryDateRules = (t, shipDateValue) => {
  const formattedShipDate = shipDateValue?.set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  return [
    {
      required: true,
      message: t('translation:default.fields.deliveryDate.message'),
    },
    {
      validator: (_, value) => {
        if (value && formattedShipDate?.isAfter(value?.set({ hour: 0, minute: 0, second: 0, millisecond: 0 }))) {
          return Promise.reject(t('translation:getQuote.shippingTermsSearch.deliveryDate.message'));
        }

        return Promise.resolve();
      },
    },
  ];
};

export const amiRules = (poValue, shipmentValue) => [
  {
    validator: (_, value) => {
      if ([value, poValue, shipmentValue].some((v) => Boolean(v))) {
        return Promise.resolve();
      }

      return Promise.reject('At least one of Billing Reference#, Shipment#, PO# field should be filled');
    },
  },
  {
    max: 20,
    message: 'Billing Reference# cannot be longer than 20 characters',
  },
];

export const poRules = (amiValue, shipmentValue) => [
  {
    validator: (_, value) => {
      if ([value, amiValue, shipmentValue].some((v) => Boolean(v))) {
        return Promise.resolve();
      }

      return Promise.reject('At least one of Billing Reference#, Shipment#, PO# field should be filled');
    },
  },
  {
    max: 100,
    message: 'PO# cannot be longer than 100 characters',
  },
];

export const incotermnamedPlaceRules = [
  {
    max: 100,
    message: 'Incoterm Named Place cannot be more than 100 characters',
  },
];
